import { createContext, useContext, useMemo, useState } from "react";

const VisitorContext = createContext(null);

export const useVisitor = () => useContext(VisitorContext);

export default function VisitorProvider({ children }) {
  const [name, setName] = useState(() => sessionStorage.getItem("visitor-name") || "");
  const [promptOpen, setPromptOpen] = useState(false);

  const value = useMemo(
    () => ({
      name,
      promptOpen,
      setPromptOpen,
      introduce: (n) => {
        const clean = (n || "").trim().slice(0, 40);
        if (!clean) return false;
        setName(clean);
        sessionStorage.setItem("visitor-name", clean);
        setPromptOpen(false);
        return true;
      },
      forget: () => {
        setName("");
        sessionStorage.removeItem("visitor-name");
        setPromptOpen(false);
      },
    }),
    [name, promptOpen]
  );

  return <VisitorContext.Provider value={value}>{children}</VisitorContext.Provider>;
}
